import setBuilder from '../../../../../Template/config/components/selection/SetBuilder'
import setBuilderToolbar from './setBuilderToolbar'


export default  {
    ...setBuilder,
    maxAdSetSize: 330,
    includeSampleSize: false,
    setBuilderToolbar
}



// WEBPACK FOOTER //
// ./src/app/configuration/CategoryQSR/config/components/selection/SetBuilder/index.js